module.exports = __webpack_public_path__ + "static/img/home_08.dc155a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_08.jpg
// module id = DIGh
// module chunks = 1